#import "../fragments/contact-summary-fragment.graphql"

mutation UpdateContactSummary($input: ContactUpdateInput!) {
    contactUpdate(input: $input) {
        contact {
            ...ContactSummaryFragment
        }
    }
}
